module.exports = __webpack_public_path__ + "7c927682d54d47da2c8c6f69588080b8.png";